<div class="w-full  animate-fade-in pb-10 relative">
    <!-- Header Shared Component -->
    <app-section-header [title]="businessParam ? 'Perfil de Negocio' : 'Registrar Entidad'"
        [description]="'Organización | ' + (businessParam ? 'Editar' : 'Nuevo Registro')"
        icon="mdi:office-building-outline" [showBack]="true">
    </app-section-header>

    <form [formGroup]="form" class="animate-fade-in">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <!-- COL 1: Identidad + Contacto -->
            <div class="space-y-4">
                <!-- Sección: Identidad -->
                <div class="compact-section space-y-4">
                    <p
                        class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                        <iconify-icon icon="mdi:information-outline" width="13" class="text-primary"></iconify-icon>
                        Identidad General
                    </p>

                    <!-- API Key Sincronización -->
                    <div class="space-y-3 p-3.5 bg-primary/5 border border-primary/10 rounded-2xl mb-2">
                        <div class="flex items-end gap-2">
                            <div class="flex-grow">
                                <app-input label="Invoicing API Key (Sincronización)" formControlName="invoiceApiKey"
                                    size="sm" icon="mdi:api" type="text"
                                    placeholder="Token para traer info de facturación"></app-input>
                            </div>
                            <div class="pb-0.5">
                                <app-button variant="primary" size="sm" iconLeft="mdi:sync" (click)="openSyncModal()"
                                    [loading]="syncLoading()"
                                    [disabled]="syncLoading() || !form.get('invoiceApiKey')?.value">
                                    Sincronizar
                                </app-button>
                            </div>
                        </div>
                        <p class="text-[8px] text-foreground/60 italic px-1 leading-tight">
                            Ingresa tu API Key para cargar dinámicamente los datos desde el Invoice API.
                        </p>
                    </div>

                    <!-- Section: Logo -->
                    <div class="space-y-3 p-3.5 bg-primary/[0.03] border border-primary/10 rounded-2xl mb-4">
                        <p
                            class="text-[9px] font-black uppercase tracking-[0.22em] text-primary/75 flex items-center gap-1.5">
                            <iconify-icon icon="mdi:image-outline" width="12"></iconify-icon>
                            Logo del Negocio
                        </p>

                        <!-- Logo Card Container -->
                        <div
                            class="p-4 bg-white/40 border border-foreground/[0.05] rounded-2xl flex items-center gap-4 transition-all hover:border-primary/20 group relative overflow-hidden">
                            <!-- Glass Blur Background -->
                            <div
                                class="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity">
                            </div>

                            <!-- Preview Container -->
                            <div
                                class="relative w-16 h-16 rounded-xl bg-white border border-foreground/[0.03] shadow-sm flex items-center justify-center overflow-hidden z-10">
                                <img *ngIf="logoPreview() || currentBusiness()?.invoiceLogoUrl"
                                    [src]="logoPreview() || getLogoUrl(currentBusiness()?.invoiceLogoUrl!)"
                                    class="w-full h-full object-contain p-2" />
                                <div *ngIf="!logoPreview() && !currentBusiness()?.invoiceLogoUrl"
                                    class="flex flex-col items-center text-foreground/10">
                                    <iconify-icon icon="mdi:image-plus" width="24"></iconify-icon>
                                </div>
                            </div>

                            <!-- Info & Actions -->
                            <div class="flex-grow z-10">
                                <div class="flex items-center gap-2 mb-1.5">
                                    <h4
                                        class="text-[10px] font-bold text-slate-800 dark:text-white/90 uppercase tracking-tight">
                                        {{ logoPreview() ? 'Nueva Imagen' : 'Marca del Negocio' }}
                                    </h4>
                                    <!-- Status Badge -->
                                    <div *ngIf="currentBusiness()?.logoLoaded && !logoPreview()"
                                        class="flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-emerald-500/10 text-emerald-600 border border-emerald-500/10 animate-fade-in">
                                        <iconify-icon icon="mdi:check-decagram" width="10"></iconify-icon>
                                        <span class="text-[7px] font-black uppercase tracking-widest">Activo</span>
                                    </div>
                                </div>

                                <div class="flex items-center gap-2">
                                    <button type="button" (click)="logoInput.click()"
                                        class="h-7 px-3 bg-primary text-white text-[8px] font-black uppercase rounded-lg hover:bg-primary/90 transition-all flex items-center gap-1.5 shadow-sm shadow-primary/20">
                                        <iconify-icon
                                            [icon]="logoPreview() || currentBusiness()?.logoLoaded ? 'mdi:sync' : 'mdi:upload'"
                                            [class]="logoPreview() ? 'animate-spin-slow' : ''"
                                            width="12"></iconify-icon>
                                        {{ logoPreview() || currentBusiness()?.logoLoaded ? 'Cambiar Logo' : 'Subir
                                        Logo'
                                        }}
                                    </button>
                                    <button *ngIf="logoPreview()" type="button" (click)="clearLogoSelection()"
                                        class="h-7 w-7 flex items-center justify-center rounded-lg bg-red-500/10 text-red-500 hover:bg-red-500/20 transition-all shadow-sm shadow-red-500/5">
                                        <iconify-icon icon="mdi:close-circle-outline" width="14"></iconify-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <app-input label="Nombre Comercial" formControlName="commercialName" size="sm"
                        icon="mdi:tag-outline" placeholder="Ej: DentalHealth"></app-input>

                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Razón Social" formControlName="name" size="sm" icon="mdi:domain"
                            [required]="true" placeholder="Ej: Clínica Dental Premium S.A."
                            [error]="fieldError('name')"></app-input>
                        <app-input label="RUC / Identificación" formControlName="taxId" size="sm"
                            icon="mdi:card-account-details-outline" [required]="true" placeholder="Ej: 1792345678001"
                            [error]="fieldError('taxId')"></app-input>
                    </div>

                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Límite de Personal (Usuarios)" formControlName="staffLimit" size="sm"
                            icon="mdi:account-group-outline" type="number" min="0"
                            placeholder="0 = Ilimitado"></app-input>

                        <div class="flex flex-col justify-center">
                            <label
                                class="p-2 bg-foreground/[0.03] border border-foreground/[0.04] rounded-xl flex items-center justify-between cursor-pointer hover:border-primary/20 transition-all">
                                <div class="flex flex-col">
                                    <span
                                        class="text-[8px] font-bold text-slate-800 dark:text-white/90 uppercase tracking-widest">Estado
                                        Operacional</span>
                                    <span class="text-[7px] text-foreground/45">Activo / Suspendido</span>
                                </div>
                                <div class="relative">
                                    <input type="checkbox" formControlName="isEnabled" class="sr-only peer">
                                    <div
                                        class="w-8 h-4.5 bg-foreground/10 rounded-full peer peer-checked:bg-emerald-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3.5 after:w-3.5 after:transition-all peer-checked:after:translate-x-3.5">
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Sección: Contacto -->
                <div class="compact-section space-y-4 flex flex-col">
                    <p class=" flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em]
                    text-foreground/60">
                        <iconify-icon icon="mdi:account-box-outline" width="13" class="text-primary"></iconify-icon>
                        Contacto &amp; Ubicación
                    </p>

                    <app-input label="Dirección Principal" formControlName="address" size="sm"
                        icon="mdi:map-marker-outline" [required]="true" placeholder="Av. Amazonas y Colón"
                        [error]="fieldError('address')"></app-input>

                    <app-input label="Dirección del Establecimiento" formControlName="establishmentAddress" size="sm"
                        icon="mdi:map-marker-radius-outline"
                        placeholder="Dirección que aparecerá en facturas (opcional)"></app-input>

                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Teléfono" formControlName="phone" size="sm" icon="mdi:phone-outline"
                            [required]="true" placeholder="022345678" [error]="fieldError('phone')"></app-input>
                        <app-input label="Email de Contacto" formControlName="email" size="sm" icon="mdi:email-outline"
                            [required]="true" placeholder="admin@clinica.com" [error]="fieldError('email')"></app-input>
                    </div>
                </div>
            </div>

            <!-- COL 2: Facturación + Tributario -->
            <div class="space-y-4">
                <!-- Sección: Configuración SRI -->
                <div class="compact-section space-y-4">
                    <p
                        class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                        <iconify-icon icon="mdi:file-certificate-outline" width="13"
                            class="text-primary"></iconify-icon>
                        Configuración SRI
                    </p>

                    <label
                        class="p-3.5 bg-foreground/[0.03] border border-foreground/[0.04] rounded-2xl flex items-center justify-between cursor-pointer hover:border-primary/20 transition-all">
                        <div class="flex flex-col">
                            <span
                                class="text-[9px] font-bold text-slate-800 dark:text-white/90 uppercase tracking-widest mb-0.5">Certificación
                                SRI</span>
                            <span class="text-[8px] text-foreground/45 italic">¿Este negocio emite facturas
                                electrónicas?</span>
                        </div>
                        <div class="relative">
                            <input type="checkbox" formControlName="hasSignature" class="sr-only peer">
                            <div
                                class="w-8 h-4.5 bg-foreground/10 rounded-full peer peer-checked:bg-primary after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3.5 after:w-3.5 after:transition-all peer-checked:after:translate-x-3.5">
                            </div>
                        </div>
                    </label>

                    <div *ngIf="form.get('hasSignature')?.value" class="animate-fade-in space-y-4">
                        <!-- Firma electrónica -->
                        <div class="space-y-3 p-3.5 bg-primary/[0.03] border border-primary/10 rounded-2xl">
                            <p
                                class="text-[9px] font-black uppercase tracking-[0.22em] text-primary/75 flex items-center gap-1.5">
                                <iconify-icon icon="mdi:shield-key-outline" width="12"></iconify-icon>
                                Firma Electrónica
                            </p>

                            <!-- Contenedor Firma -->
                            <div class="space-y-3">
                                <!-- Estado: Firma Cargada -->
                                <div *ngIf="currentBusiness()?.signatureLoaded && !signatureFileName()"
                                    class="p-4 bg-emerald-500/5 border border-emerald-500/10 rounded-2xl flex items-center justify-between group">
                                    <div class="flex items-center gap-3">
                                        <div
                                            class="w-10 h-10 rounded-xl bg-emerald-500/10 flex items-center justify-center text-emerald-500">
                                            <iconify-icon icon="mdi:shield-check" width="22"></iconify-icon>
                                        </div>
                                        <div class="flex flex-col">
                                            <span
                                                class="text-[10px] font-black uppercase tracking-tight text-emerald-600">Certificado
                                                Activo</span>
                                            <span
                                                class="text-[8px] text-emerald-500/60 font-medium uppercase tracking-widest">Sincronizado</span>
                                        </div>
                                    </div>
                                    <button type="button" (click)="signatureInput.click()"
                                        class="px-3 py-1.5 rounded-lg bg-emerald-500/10 text-emerald-600 text-[9px] font-black uppercase hover:bg-emerald-500/20 transition-all flex items-center gap-1.5">
                                        <iconify-icon icon="mdi:sync" width="12"></iconify-icon>
                                        Reemplazar
                                    </button>
                                </div>

                                <!-- Carga de Firma -->
                                <div *ngIf="!currentBusiness()?.signatureLoaded || signatureFileName()"
                                    class="animate-fade-in space-y-3">
                                    <div *ngIf="signatureFileName()"
                                        class="flex items-center justify-between px-3 py-2 bg-primary/5 border border-primary/20 rounded-xl">
                                        <span class="text-[9px] font-black uppercase text-primary">Archivo: {{
                                            signatureFileName() }}</span>
                                        <button type="button" (click)="clearSignatureSelection()"
                                            class="text-red-500 bg-red-500/10 px-2 py-1 rounded text-[8px] font-black uppercase">Cancelar</button>
                                    </div>

                                    <div (click)="signatureInput.click()"
                                        class="w-full p-6 border-2 border-dashed border-foreground/10 rounded-2xl flex flex-col items-center justify-center gap-2 cursor-pointer hover:border-primary/30 hover:bg-primary/5 transition-all">
                                        <iconify-icon
                                            [icon]="signatureFileName() ? 'mdi:file-certificate' : 'mdi:cloud-upload-outline'"
                                            [class.text-primary]="signatureFileName()" width="28"></iconify-icon>
                                        <span class="text-[10px] font-black uppercase">{{ signatureFileName() ||
                                            'Seleccionar Firma .p12' }}</span>
                                    </div>


                                    <app-input label="Contraseña de la Firma" formControlName="signaturePassword"
                                        size="sm" type="password" icon="mdi:lock-outline"></app-input>
                                </div>
                            </div>
                        </div>

                        <!-- Establecimiento / Punto -->
                        <div class="grid grid-cols-2 gap-3">
                            <app-input label="Establecimiento" formControlName="establishmentCode" size="sm"
                                inputClass="font-bold text-center" placeholder="001"></app-input>
                            <app-input label="Punto de Emisión" formControlName="emissionPointCode" size="sm"
                                inputClass="font-bold text-center" placeholder="001"></app-input>
                        </div>

                        <app-select label="Ambiente SRI" formControlName="environment" [options]="envOptions" size="sm"
                            icon="mdi:cloud-outline"></app-select>
                    </div>
                </div>

                <!-- Sección: Tributación -->
                <div class="compact-section space-y-4">
                    <p
                        class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                        <iconify-icon icon="mdi:gavel" width="13" class="text-primary"></iconify-icon>
                        Tributación &amp; Régimen
                    </p>

                    <div class="space-y-3">
                        <label
                            class="p-3 bg-foreground/[0.02] border border-foreground/[0.04] rounded-xl flex items-center justify-between cursor-pointer">
                            <span
                                class="text-[9px] font-bold text-slate-800 dark:text-white/90/60 uppercase tracking-widest">Obligado
                                Contabilidad</span>
                            <div class="relative">
                                <input type="checkbox" formControlName="obligadoContabilidad" class="sr-only peer">
                                <div
                                    class="w-8 h-4.5 bg-foreground/10 rounded-full peer peer-checked:bg-primary after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3.5 after:w-3.5 after:transition-all peer-checked:after:translate-x-3.5">
                                </div>
                            </div>
                        </label>

                        <label
                            class="p-3 bg-foreground/[0.02] border border-foreground/[0.04] rounded-xl flex items-center justify-between cursor-pointer">
                            <span
                                class="text-[9px] font-bold text-slate-800 dark:text-white/90/60 uppercase tracking-widest">Contribuyente
                                Especial</span>
                            <div class="relative">
                                <input type="checkbox" formControlName="isSpecialTaxpayer" class="sr-only peer">
                                <div
                                    class="w-8 h-4.5 bg-foreground/10 rounded-full peer peer-checked:bg-primary after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3.5 after:w-3.5 after:transition-all peer-checked:after:translate-x-3.5">
                                </div>
                            </div>
                        </label>

                        <div *ngIf="form.get('isSpecialTaxpayer')?.value" class="animate-fade-in pt-1">
                            <app-input label="Resolución CE" formControlName="specialTaxpayerResolution" size="sm"
                                icon="mdi:certificate-outline" placeholder="Nro de Resolución SRI"></app-input>
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Tipo de Régimen" formControlName="regimenType" size="sm"
                            placeholder="REGIMEN GENERAL"></app-input>
                    </div>
                </div>
            </div>
        </div>

        <!-- Módulos (Full Width) -->
        <div class="mt-6 compact-section space-y-4">
            <div class="flex items-center justify-between">
                <p class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                    <iconify-icon icon="mdi:shield-lock-outline" width="13" class="text-primary"></iconify-icon>
                    Módulos &amp; Permisos
                </p>
                <div class="flex items-center gap-2">
                    <app-button variant="glass" size="xs" (click)="clearAllPermissions()">Limpiar</app-button>
                    <app-button variant="glass" size="xs" (click)="grantAllPermissions()">Todos</app-button>
                </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                <div *ngFor="let module of availableModules()"
                    class="p-3 bg-foreground/[0.02] border border-foreground/[0.04] rounded-xl space-y-2">
                    <label class="flex items-center justify-between cursor-pointer">
                        <span class="text-[9px] font-black uppercase tracking-tight text-foreground/70">{{ module.label
                            }}</span>
                        <input type="checkbox" [checked]="isModuleFullyEnabled(module)"
                            [indeterminate]="isModulePartial(module)" (change)="toggleModule(module, $event)"
                            class="accent-primary">
                    </label>
                    <div class="flex flex-wrap gap-1">
                        <label *ngFor="let action of module.actions" class="flex items-center gap-1 cursor-pointer">
                            <input type="checkbox" [checked]="isPermissionEnabled(module.name + ':' + action.key)"
                                (change)="togglePermission(module.name + ':' + action.key, $event)"
                                class="w-3 h-3 accent-primary">
                            <span class="text-[8px] font-bold text-foreground/50 uppercase">{{ action.label }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!-- Colaboradores (Edición) -->
        <div *ngIf="businessParam" class="mt-6 compact-section space-y-4">
            <div class="flex items-center justify-between">
                <p class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                    <iconify-icon icon="mdi:account-group-outline" width="13" class="text-primary"></iconify-icon>
                    Equipo de Trabajo
                </p>
                <app-button (click)="addCollaborator()" variant="glass" size="xs" iconLeft="mdi:plus">Agregar
                    Miembro</app-button>
            </div>

            <div *ngIf="loadingCollaborators()" class="py-10 flex justify-center">
                <div class="w-6 h-6 border-2 border-primary/20 border-t-primary rounded-full animate-spin"></div>
            </div>

            <div *ngFor="let member of collaborators()"
                class="flex items-center justify-between p-3 bg-foreground/[0.02] border border-foreground/[0.04] rounded-xl group transition-all hover:border-primary/20">
                <div class="flex items-center gap-3">
                    <div
                        class="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary border border-primary/20">
                        <iconify-icon icon="mdi:account" width="16"></iconify-icon>
                    </div>
                    <div>
                        <p class="text-[10px] font-bold text-slate-800 dark:text-white/90 uppercase">{{
                            $any(member.user)?.fullName ||
                            'Invitado' }}</p>
                        <p class="text-[8px] text-foreground/75 uppercase">{{ $any(member.user)?.email || '-' }}</p>
                    </div>
                </div>
                <button (click)="removeCollaborator(member.id)"
                    class="opacity-0 group-hover:opacity-100 p-2 text-red-500 hover:bg-red-500/10 rounded-lg transition-all">
                    <iconify-icon icon="mdi:trash-can-outline" width="16"></iconify-icon>
                </button>
            </div>
        </div>

        <!-- Footer -->
        <div class="mt-8 space-y-4">
            <div *ngIf="error()" class="p-3 rounded-xl bg-red-500/5 border border-red-500/10 flex items-center gap-2">
                <iconify-icon icon="mdi:alert-circle-outline" class="text-red-500" width="16"></iconify-icon>
                <p class="text-[10px] font-black text-red-500 uppercase tracking-widest">{{ error() }}</p>
            </div>

            <div class="flex items-center justify-end gap-3">
                <app-button (click)="goBack()" variant="outline" size="xs" iconLeft="mdi:cancel"
                    class="h-9 px-6 text-[9px] font-black uppercase">Cancelar</app-button>
                <app-button (click)="save()" [disabled]="saving() || form.invalid" [loading]="saving()" size="xs"
                    variant="primary" class="h-9 px-10 text-[9px] font-black uppercase shadow-lg shadow-primary/20"
                    [iconLeft]="businessParam ? 'mdi:content-save-outline' : 'mdi:plus'">
                    {{ businessParam ? 'Guardar Cambios' : 'Registrar Negocio' }}
                </app-button>
            </div>
        </div>

        <input #logoInput type="file" (change)="onFileSelected($event, 'logo')" accept="image/*" class="hidden" />
        <input #signatureInput type="file" (change)="onSignatureFileSelected($event)" accept=".p12,.pfx"
            class="hidden" />
    </form>


</div>
<!-- Interactive Sync Dialog -->
<app-dialog [isOpen]="isSyncModalOpen()" (isOpenChange)="isSyncModalOpen.set($any($event))"
    title="Sincronizar Estructura" description="Seleccione el establecimiento y punto de emisión del API de Facturación"
    icon="mdi:sync" [isStatic]="true" width="450px">

    <div class="space-y-6 pt-2">
        <!-- Loading State -->
        <div *ngIf="syncLoading()" class="flex flex-col items-center py-8 gap-3">
            <div class="w-10 h-10 rounded-full border-4 border-primary/20 border-t-primary animate-spin"></div>
            <p class="text-[10px] font-black uppercase tracking-widest text-foreground/45">Consultando Datos Remotos...
            </p>
        </div>

        <!-- Sync Error Alert -->
        <div *ngIf="syncError()"
            class="animate-fade-in p-4 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-start gap-4">
            <iconify-icon icon="mdi:alert-circle-outline" class="text-red-600 mt-1" width="20"></iconify-icon>
            <div class="space-y-1 overflow-hidden">
                <p class="text-[10px] font-black uppercase text-red-600 tracking-tight">Error en Sincronización</p>
                <p class="text-[11px] text-red-600/90 font-bold leading-relaxed break-words">{{ syncError() }}</p>
            </div>
            <button (click)="syncError.set('')"
                class="ml-auto p-1 text-red-600/50 hover:text-red-600 transition-colors">
                <iconify-icon icon="mdi:close" width="16"></iconify-icon>
            </button>
        </div>

        <div *ngIf="!syncLoading()" class="space-y-5">
            <!-- Establishment Section -->
            <div class="space-y-3">
                <div class="flex items-center justify-between gap-4">
                    <p
                        class="text-[9px] font-black uppercase tracking-widest text-foreground/45 flex items-center gap-1.5">
                        <iconify-icon icon="mdi:store-outline" width="12"></iconify-icon>
                        Establecimiento
                    </p>
                    <button type="button" (click)="toggleCreateEst()"
                        class="text-[8px] font-black uppercase tracking-widest px-2 py-1 rounded-lg transition-all"
                        [class]="isCreatingEst() ? 'text-red-500 bg-red-500/10 hover:bg-red-500/20' : 'text-primary bg-primary/10 hover:bg-primary/20'">
                        {{ isCreatingEst() ? 'Cancelar' : '+ Nuevo' }}
                    </button>
                </div>

                <!-- Create Mode -->
                <div *ngIf="isCreatingEst()"
                    class="animate-fade-in p-4 bg-primary/[0.03] border border-primary/10 rounded-2xl space-y-4">
                    <div class="grid grid-cols-4 gap-3">
                        <div class="col-span-1">
                            <app-input label="Código" [(ngModel)]="newEst().code" size="sm" placeholder="001"
                                centerValue="true"></app-input>
                        </div>
                        <div class="col-span-3">
                            <app-input label="Nombre del local" [(ngModel)]="newEst().name" size="sm"
                                placeholder="Ej: Sucursal Centro"></app-input>
                        </div>
                    </div>
                    <app-input label="Dirección" [(ngModel)]="newEst().address" size="sm"
                        placeholder="Av. Principal Nro 123"></app-input>
                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Teléfono" [(ngModel)]="newEst().phone" size="sm"
                            placeholder="022345678"></app-input>
                        <app-input label="Email" [(ngModel)]="newEst().email" size="sm"
                            placeholder="local@negocio.com"></app-input>
                    </div>
                    <app-button (click)="createRemoteEstablishment()" [disabled]="!newEst().code || !newEst().name"
                        variant="primary" size="xs" class="w-full font-black uppercase tracking-widest">
                        Crear Establecimiento
                    </app-button>
                </div>

                <!-- Selection Mode -->
                <div *ngIf="!isCreatingEst()" class="space-y-2">
                    <app-select label="Seleccionar" placeholder="Seleccione un establecimiento"
                        [options]="establishmentOptions" [ngModel]="selectedEstablishmentId()"
                        (ngModelChange)="onEstablishmentChange($any($event))" icon="mdi:store-check-outline"
                        [insideDialog]="true"></app-select>

                    <div *ngIf="selectedEstablishmentId()"
                        class="flex items-center gap-2 px-3 py-2 bg-primary/5 rounded-xl border border-primary/10">
                        <iconify-icon icon="mdi:information-outline" class="text-primary" width="12"></iconify-icon>
                        <p class="text-[9px] font-bold text-primary uppercase">Código Detectado: {{ tempEstCode() }}</p>
                    </div>
                </div>
            </div>

            <!-- Emission Point Section -->
            <div class="space-y-3" *ngIf="selectedEstablishmentId() && !isCreatingEst()">
                <div class="flex items-center justify-between gap-4 border-t border-foreground/[0.03] pt-4">
                    <p
                        class="text-[9px] font-black uppercase tracking-widest text-foreground/45 flex items-center gap-1.5">
                        <iconify-icon icon="mdi:map-marker-radius-outline" width="12"></iconify-icon>
                        Punto de Emisión
                    </p>
                    <button type="button" (click)="toggleCreatePnt()"
                        class="text-[8px] font-black uppercase tracking-widest px-2 py-1 rounded-lg transition-all"
                        [class]="isCreatingPnt() ? 'text-red-500 bg-red-500/10 hover:bg-red-500/20' : 'text-emerald-600 bg-emerald-500/10 hover:bg-emerald-500/20'">
                        {{ isCreatingPnt() ? 'Cancelar' : '+ Nuevo' }}
                    </button>
                </div>

                <!-- Create Mode -->
                <div *ngIf="isCreatingPnt()"
                    class="animate-fade-in p-4 bg-emerald-500/[0.03] border border-emerald-500/10 rounded-2xl space-y-4">
                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Código (Punto)" [(ngModel)]="newPnt().code" size="sm" placeholder="001"
                            centerValue="true"></app-input>
                        <app-input label="Secuencial Inicial" [(ngModel)]="newPnt().sequential" type="number" size="sm"
                            placeholder="1" centerValue="true"></app-input>
                    </div>
                    <app-button (click)="createRemoteEmissionPoint()" [disabled]="!newPnt().code" variant="primary"
                        size="xs"
                        class="w-full font-black uppercase tracking-widest bg-emerald-600 hover:bg-emerald-700 shadow-emerald-500/20">
                        Crear Punto de Emisión
                    </app-button>
                </div>

                <!-- Selection Mode -->
                <div *ngIf="!isCreatingPnt()" class="space-y-2">
                    <app-select label="Seleccionar" placeholder="Seleccione un punto de emisión"
                        [options]="emissionPointOptions" [ngModel]="selectedEmissionPointId()"
                        (ngModelChange)="onEmissionPointChange($any($event))" icon="mdi:map-marker-check-outline"
                        [insideDialog]="true"></app-select>

                    <div *ngIf="selectedEmissionPointId()"
                        class="flex items-center gap-2 px-3 py-2 bg-emerald-500/5 rounded-xl border border-emerald-500/10">
                        <iconify-icon icon="mdi:check-circle-outline" class="text-emerald-600"
                            width="12"></iconify-icon>
                        <p class="text-[9px] font-bold text-emerald-600 uppercase">Punto de Emisión: {{ tempPntCode() }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="p-3.5 rounded-2xl bg-amber-500/[0.03] border border-amber-500/10 flex items-start gap-3"
                *ngIf="!isCreatingEst() && !isCreatingPnt()">
                <iconify-icon icon="mdi:alert-circle-outline" class="text-amber-600/70" width="16"></iconify-icon>
                <p class="text-[9px] text-amber-700/70 leading-tight font-bold uppercase tracking-tight">
                    Al confirmar, se actualizarán los códigos en el formulario. Deberá presionar "Guardar" para
                    persistir los cambios.
                </p>
            </div>
        </div>

        <div class="flex items-center gap-3 pt-4">
            <app-button (click)="closeSyncModal()" variant="glass" size="sm"
                class="flex-1 font-bold uppercase text-[10px]">
                Cancelar
            </app-button>
            <app-button (click)="applySyncSelection()" [disabled]="!selectedEmissionPointId()" variant="primary"
                size="sm" class="flex-1 font-black uppercase text-[10px]">
                Confirmar Selección
            </app-button>
        </div>
    </div>
</app-dialog>